const rules = {
    regadmin: {
      static: [
        "spots:delete",
        "photos:delete"
      ]
    }
  };
  
export default rules;